<material-navbar
  [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')"
>
</material-navbar>
<!-- <div class="container">
  <div class="heading">Contact Us</div>
  <div class="sub-heading">
    Any question or remarks? Just write us a message!
  </div>
</div> -->
<section class="contact-us-section">
  <div class="container">
    <div class="row">
      <div class="offset-lg-4 col-lg-4 offset-lg-3 col-md-6">
        <div class="card text-center">
          <h1>Thank You</h1>
          <p>Thank you for being a part of our journey. Whether you choose to stay or leave, we value your support and the connection we've built.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer class="footer"></app-footer>
